import React from 'react';

const CodeConsole = ({ language = 'python', code }) => {
  const containerStyle = {
    backgroundColor: '#f5f5f5', // Light background
    color: '#333',              // Dark text for readability
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    margin: '16px 0',
    border: '1px solid #ddd',
  };

  const headerStyle = {
    backgroundColor: '#eaeaea', // Light gray header
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '600',
    borderBottom: '1px solid #ccc',
    color: '#222',
  };

  const preStyle = {
    overflowX: 'auto',
    padding: '12px 16px',
    fontSize: '14px',
    margin: 0,
    backgroundColor: '#ffffff', // White background for code
    color: '#111',              // Dark text
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        {/* {language.charAt(0).toUpperCase() + language.slice(1)} */}
        Code
      </div>
      <pre style={preStyle}>
        <code className={`language-${language}`}>{code}</code>
      </pre>
    </div>
  );
};

export default CodeConsole;
